import React from 'react'
import renderHtml from 'react-render-html'

const EventEntry = ({ schedule }) => {
  const { title, marketingLink, isInternalLink } = schedule
  const getBackgroundColor = (category) => {
    let backgroundColor
    switch (category) {
      case 'Sports':
        backgroundColor = '#3D4D55'
        break;
      case 'Food':
        backgroundColor = '#F3AE92'
        break;
      case 'Concerts':
        backgroundColor = '#C0D1C6'
        break;
      case 'Art':
        backgroundColor = '#B78C30'
        break;
      case 'Music':
        backgroundColor = '#F15A29'
        break;
      case 'Art Event':
        backgroundColor = '#DCC4B8'
        break;
      case 'Music Concerts':
        backgroundColor = '#F78D1E'
        break;
      case 'Sporting Event':
        backgroundColor = '#5C7096'
        break;
      default:
        backgroundColor = '#FFF'
        break;
    }
    return backgroundColor
  }
  
  return (
    <div className="event-entry">
      <div className="event-entry__category-marker" style={{backgroundColor: `${getBackgroundColor(schedule.categories[0])}`}}/>
      {marketingLink ? (
        <a
          href={marketingLink}
          target={!isInternalLink ? '_blank' : '_self'}
          rel="noopener noreferrer"
          className="event-cta-link"
        >
          {renderHtml(title)}
        </a>
      ) : (
        <p className="event-title">{renderHtml(title)}</p>
      )}
    </div>
  )
}

export default EventEntry
